import {getNext} from "../operations/zoom";

webix.protoUI(
	{
		name: "ssheet-zoom",
		$cssName: "counter webix_ssheet_zoom",
		$init: function() {
			this.attachEvent("onAfterRender", () => {
				this.$setValue(this.config.value);
				this.getInputNode().readOnly = true;
				webix.event(this.$view.firstChild, "keydown", e =>
					webix.html.preventEvent(e)
				);
			});
		},
		$setValue: function(value) {
			this.getInputNode().value = parseInt(value * 100, 10) + "%";
		},
		shift: function(step, config) {
			const v = this.config.value;
			const arr = this.config.numbers;

			const value = getNext(v, step, arr);
			this.setValue(value, config);
		},
	},
	webix.ui.counter
);